import { Model } from '../abstract/model.abstract';

export class LanguageModel extends Model {
  id?: number;
  code?: string;
  title?: string;
}
